import React, { Component } from 'react';
import './KPI7.css';

import Select from '@acri-tools/react-tools/components/Select/Select';
import KPIs from '../KPIs';
import { date_timezone_compensated, get_graph_mode, get_month_dates, get_timeline_height, is_on_kpi_page, update_kpi_url } from '../../../_utils/kpi';
import FormFieldCheckbox from '@acri-tools/react-tools/components/FormFieldCheckbox/FormFieldCheckbox';
import Tabs from '@acri-tools/react-tools/components/Tabs/Tabs';
import Timeline from '../../../components/Timeline/Timeline';
import { getDateTimeString } from '@acri-tools/react-tools/utils/date';
import moment from 'moment';
import { drawPlugin } from '../../../_utils/graphs';
import { Scatter } from 'react-chartjs-2';
import { VerticalLinePlugin } from '../../../_utils/graphs';
import zoomPlugin from 'chartjs-plugin-zoom';
import * as Chart from 'chart.js';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import request from '@acri-tools/react-tools/utils/request';
import { API_URL } from '../../../_utils/config';
import { axiosErrorHandler, nullUndefined } from '@acri-tools/react-tools/utils/global';
import { connect } from 'react-redux';
import KPITable from '../../../components/KPITable/KPITable';
import classNames from 'classnames';
import { get_product_type_id, load_product_types } from '../../../_utils/product_types';
import { get_date_difference, to_local_iso_string } from '../../../_utils/date';
import KPIRefreshOverlay from '../../../components/KPIRefreshOverlay/KPIRefreshOverlay';
import * as chroma from 'chroma-js';
import TimelinessChart from '../../../components/TimelinessChart/TimelinessChart';
Chart.plugins.register(zoomPlugin);

const COLORS = [
    "#14B2BE",
    "#E0B620",
    "#96BA55",
    "#96113D",
    "#A913BA",
    "#396581",
    "#551E21",
    "#ED64A9",
    "#14D54A",
]
const COMPLETENESS_COLORS = chroma.scale(['#f73a3a', '#f7ab3a', '#f7db3a', '#6eb4f7']);
// const COMPLETENESS_COLORS = chroma.scale(['red', 'orange', 'yellow', 'green']);
// const COLORS = chroma.scale(['yellow', 'navy']).mode('lch').colors(10, 'rgb').map((c:any)=>{ return `rgb(${c[0]},${c[1]},${c[2]})` });
// console.debug(COLORS);

const FILTER_TIME_MAX = 1000*60*60*24*7;

interface Props {

    // REDUX
    product_types?: any
    kpi?: any
}
interface State {
    loading: boolean
    refreshing: boolean

    graph_modes?: Array<any>
    graphMode?: any
    base_graphMode?: string


    startDate: string
    stopDate: string

    base_startDate?: string
    base_stopDate?: string

    updateStartDate: string
    updateStopDate: string



    completeness: boolean
    timeliness: boolean
    drag_mode: boolean


    // data
    timeliness_data?: any
    // completeness
    downlink_session_data?: any
    completeness_data?: any
    completeness_graph_data?: any
    timeline_rows?: number
    data_labels?: string[]

    // product_types
    toggled_products: { [key: string]: boolean }
    // export
    json_format: boolean
}
/**
 *  1. KPI SELECT
 *  2. 2 graphs, 1 per toggle seperated
 *      timeliness : scatter graph with duration / complete_date
 *      completeness start - stop - product-type
 *            (like kpi 2 - timeline): 
 *          - orbits start- stop
 *          - product 
 */
class KPI7 extends Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            toggled_products: {},
            refreshing: false,
            loading: false,
            ...this.default_values(true),

            completeness: true,
            timeliness: true,
            drag_mode: false,

            json_format: false,
        }
    }
    async componentDidMount() {
        await load_product_types()
        await this.fetch_graph_modes();

        this.default_values(true)

        this.fetch_data(true)
    }
    async componentDidUpdate(prevProps: Props) {
        if (prevProps.kpi?.refresh !== this.props.kpi?.refresh) {
            await this.setState({
                ...this.default_values(true)
            })
            if (is_on_kpi_page(7)) {
                this.update_url()
            }
            this.fetch_data(true)
        }
    }

    get_graph_mode = () => {
        return this.state.graphMode ? this.state.graph_modes?.find((gm: any) => gm.name === this.state.graphMode) : null;
    }

    default_values = (set_base?: boolean) => {
        return {
            ...get_graph_mode(this.state, set_base, this.state?.graph_modes),
            ...get_month_dates(this.state, set_base)
        }
    }

    fetch_graph_modes = async () => {
        try {
            let res = await request(`${API_URL}/api/v1/kpi_7_graph_modes`, {
                method: 'get',
                params: {
                    limit: 4500,
                }
            })
            await this.setState({
                graph_modes: res.data.value,
                ...get_graph_mode(this.state, true, res.data.value)
            })
        }
        catch (e) {
            axiosErrorHandler(e, {
                functionName: 'fetch_graph_modes'
            })
        }
    }

    fetch_data = async (refresh?: boolean) => {
        if (refresh) this.setState({ refreshing: true, loading: true });
        else this.setState({ loading: true });
        let graphMode = this.get_graph_mode();
        if (!graphMode) return;
        try {
            let promises = [];
            let gm_products = graphMode?.products;

            if (gm_products) {
                // If refresh all data, then reset toggled products
                if (refresh) {
                    let toggled_products: any = {};
                    gm_products.forEach((product: any, idx: number) => {
                        toggled_products[idx] = true;
                    })
                    await this.setState({ toggled_products })
                }

                // COMPLETENESS & TIMELINESS
                if (refresh) await this.setState({ completeness_data: {}, timeliness_data: {} });
                promises.push(this.fetch_downlink_session_data());
                gm_products.forEach((product: any, idx: number) => {
                    if (idx in this.state.toggled_products && this.state.toggled_products[idx])
                        promises.push(this.fetch_eumetsat_data(product, idx));
                })
            }

            // console.debug("promises", promises);

            let results: any[] = await Promise.all(promises);

            // console.debug("results", results);

            let downlink_session = results.shift();

            // console.debug("downlink_session_data", downlink_session);

            // FORMAT COMPLETENESS FROM DOWNLINK_SESSION

            let downlink_session_object: any = {};
            downlink_session.forEach((ds: any, index: number) => {
                downlink_session_object[ds.name] = {
                    name: ds.name,
                    description: {
                        max: 0,
                        treated: 0,
                    },
                    data: [{
                        x: 'Downlink sessions',
                        y: [
                            date_timezone_compensated(ds.start_date_time)?.getTime(),
                            date_timezone_compensated(ds.stop_date_time)?.getTime(),
                        ],
                        fillColor: index % 2 === 0 ? "#2dbf35" : "#8ecc82"
                    }]
                }
            })
            let completeness_data: any[] = results?.map((data: any, index: number) => {
                let completeness = JSON.parse(JSON.stringify(downlink_session_object));
                data.map((d: any, key: number) => {
                    completeness[d.downlink_session_name].description.max++;
                    if (d.upload_date) completeness[d.downlink_session_name].description.treated++;
                })
                return Object.values(completeness).map((ds: any) => {

                    ds.data[0].x = this.product_string(gm_products[index]);
                    ds.description.value = (ds.description.treated / ds.description.max);
                    ds.description.percentage = `${ds.description.value ? (ds.description.value * 100).toFixed(1).toString() : 0}%`;

                    ds.data[0].fillColor = COMPLETENESS_COLORS(ds.description.value).toString();

                    ds.data[0].description = ds.description;

                    return ds;
                })
            })

            // console.debug('completeness_data', completeness_data);

            let downlink_session_data = Object.values(downlink_session_object);

            this.setState({
                downlink_session_data,
                timeliness_data: results,
                completeness_data,
                timeline_rows: this.get_timeline_rows(),
                data_labels: this.get_data_labels(),
                completeness_graph_data: this.set_graph_data(downlink_session_data, completeness_data)
            });
        }
        catch (e) {
            console.error('fetch_data error', e);
        }
        finally {
            // this.setState({ loading: false })
            if (refresh) this.setState({ refreshing: false, loading: false });
            else this.setState({ loading: false });
        }
    }

    fetch_downlink_session_data = async () => {
        try {
            const hours = 7;
            let start = new Date(new Date(this.state.startDate).getTime() - hours * 60 * 60 * 1000);
            let stop = new Date(new Date(this.state.stopDate).getTime() + hours * 60 * 60 * 1000);

            let res = await request(`${API_URL}/api/v1/downlink_sessions`, {
                method: 'get',
                params: {
                    limit: 4500,
                    filter: `start_date_time ge '${getDateTimeString(start, true, true)}' 
                        and stop_date_time le '${getDateTimeString(stop, true, true)}'
                        `,
                    orderby: 'stop_date_time DESC'
                }
            })
            return res.data.value;

        }
        catch (e) {
            axiosErrorHandler(e, {
                functionName: 'fetch_orbit_data',
            })
        }
    }
    fetch_eumetsat_data = async (product: any, index: number) => {
        try {
            let product_type = product.product_type;
            if (nullUndefined(product_type)) {
                throw `Error fetching product type id`;
            }

            let res = await request(`${API_URL}/api/v1/eumetsat`, {
                method: 'get',
                params: {
                    limit: 4500,
                    // orderby:'start_date_time DESC',
                    filter: `product/product_type eq '${product_type}'
                        and downlink_session/stop_date_time ge '${this.state.startDate}'
                        and downlink_session/stop_date_time le '${this.state.stopDate}'
                    `
                }
            })

            return res.data.value?.map((v: any) => {
                v.duration = v.upload_date ?
                    (new Date(v.upload_date).getTime() - new Date(v.downlink_session.stop_date_time + 'Z').getTime()) / (60 * 1000)
                    : null;
                return v;
            });
        }
        catch (e) {
            axiosErrorHandler(e, {
                functionName: 'fetch_eumetsat_data'
            })
        }
    }

    update_url = () => {
        update_kpi_url(7, {
            startDate: to_local_iso_string(this.state.startDate),
            stopDate: to_local_iso_string(this.state.stopDate),
            graphMode: this.state.graphMode
        })
    }

    update_filter = async (update: any) => {
        await this.setState(update);
        this.fetch_data();
    }

    applyChanges = async () => {
        await this.setState({
            startDate: this.state.updateStartDate,
            stopDate: this.state.updateStopDate
        })
        this.update_url()
        this.fetch_data()
    }

    get_toggled_products = () => {
        // return Object.keys(this.state.toggled_products).filter((product:string, idx:number)=> this.state.toggled_products[idx] ) || [];
        let graphMode = this.get_graph_mode();
        return graphMode?.products.filter((product: any, idx: number) => this.state.toggled_products[idx]);
    }

    get_timeline_style = () => {
        let nb_pt = this.get_toggled_products().length || 0;
        let height = get_timeline_height(nb_pt, true)
        return {
            height
        }
    }

    product_string = (product: any, new_line?: boolean) => {
        return `${product.product_type}`;
    }

    get_product_index = (product: any) => {
        let graphMode = this.get_graph_mode();
        return graphMode?.products?.indexOf(product);
    }

    reset = async () => {
        await this.setState({
            ...this.default_values()
        })
        this.fetch_data(true);
    }

    // COMPLETENESS
    get_data_labels = () => {
        let data_labels: string[] = [
            'Downlink sessions'
        ];
        let toggled_products = this.get_toggled_products();

        toggled_products?.forEach((tp: any) => {
            data_labels.push(this.product_string(tp))
        })

        return data_labels.length > 0 ? data_labels : undefined
    }
    get_timeline_rows = () => {
        return (this.get_toggled_products()?.length || 0) + 1;
    }

    set_graph_data = (downlink_session_data?: any, completeness_data?: any) => {
        let toggled_products = this.get_toggled_products();
        if (!downlink_session_data) downlink_session_data = this.state.downlink_session_data;
        if (!completeness_data) completeness_data = this.state.completeness_data;

        let graph_data: Array<any> = [
            ...downlink_session_data || []
        ];

        // console.log("completeness_data", completeness_data)
        toggled_products?.forEach((p: any,) => {
            let idx = this.get_product_index(p);
            graph_data.push(...completeness_data?.[idx] || []);
        });
        return graph_data;

        // this.setState({ graph_data })
    }

    update_toggled_products = async (toggled_products: any) => {
        await this.setState({ toggled_products });
        this.setState({
            timeline_rows: this.get_timeline_rows(),
            data_labels: this.get_data_labels(),
            completeness_graph_data: this.set_graph_data()
        });
    }



    render() {
        let graphMode = this.get_graph_mode();
        let toggled_products = this.get_toggled_products();
        let toggled_product_names = toggled_products?.map((p: any) => { return this.product_string(p); });
        let _state: any = { ...this.state }

        // let date_surpassed = false;
        // let date_surpassed = (new Date(this.state.updateStopDate).getTime() - new Date(this.state.updateStartDate).getTime()) > FILTER_TIME_MAX;

        return (
            <KPIs
                title="Sentinel-3 EUMETSAT Interfaces Performance"
            >
                <div className="row-2">
                    <div className="row-2">
                        <div className="form-field">
                            <label>Start Date</label>
                            <input type="datetime-local"
                                value={this.state.updateStartDate}
                                // onChange={(e) => { this.update_filter({ updateStartDate: e.target.value }) }}
                                onChange={async (e) => {
                                    this.setState({ updateStartDate: e.target.value });
                                }}
                            />
                        </div>
                        <div className="form-field">
                            <label>Stop Date</label>
                            <input type="datetime-local"
                                value={this.state.updateStopDate}
                                // onChange={(e) => { this.update_filter({ updateStopDate: e.target.value }) }}
                                onChange={async (e) => {
                                    this.setState({ updateStopDate: e.target.value });
                                }}
                            />
                        </div>
                    </div>
                    <div className="row-2">
                        {
                            this.state.graph_modes &&
                            <div className="form-field">
                                <label>Select Graph Mode</label>
                                <Select
                                    search
                                    value={this.state.graphMode}
                                    onChange={async (graphMode: any) => {
                                        await this.setState({ graphMode });
                                        this.update_url()
                                        this.fetch_data(true)
                                    }}
                                    // options={this.state.graph_modes.map((gm) => { return { label: gm.name, value: gm } })}
                                    options={this.state.graph_modes.map((gm) => { return { label: gm.name, value: gm.name } })}
                                />
                            </div>
                        }
                    </div>
                </div>
                {/* <div className="filter-buttons">
                    <div 
                        className={classNames({
                            "button-with-dialog": true,
                            "dialog-actif": date_surpassed
                        })} 
                    >
                        <div className={
                            classNames({
                                "custom-button small alt inline apply-changes": true,
                                "disabled": !(
                                    this.state.updateStartDate !== this.state.startDate
                                    || this.state.updateStopDate !== this.state.stopDate
                                ) || date_surpassed
                            })}
                            onClick={this.applyChanges}
                        >
                            <i className="fas fa-check" /> Apply Changes
                        </div>
                        {
                            date_surpassed &&
                            <div className="custom-button-dialog">
                                Please select a smaller time frame. 7 Days max.
                            </div>
                        }
                    </div>
                </div> */}

                <div className={
                    classNames({
                        "custom-button small alt inline apply-changes": true,
                        "disabled": !(
                            this.state.updateStartDate !== this.state.startDate
                            || this.state.updateStopDate !== this.state.stopDate
                        ) 
                        // || date_surpassed
                    })}
                    onClick={this.applyChanges}
                >
                    <i className="fas fa-check" /> Apply Changes
                </div>
                <div className="custom-button small alt inline" onClick={this.reset}>
                    <i className="fas fa-redo-alt" /> Reset Filters
                </div>
                <br />
                <br />

                <div className="row-2">
                    <div className="measurements">
                        <div className="form-field">
                            <label>timeliness service</label>
                        </div>
                        <FormFieldCheckbox
                            notSolid
                            label="All"
                            value={['completeness', 'timeliness'].every((v) => _state[v])}
                            onChange={(val: boolean) => {
                                this.setState({
                                    completeness: val,
                                    timeliness: val,
                                })
                            }}
                        />
                        <FormFieldCheckbox
                            notSolid
                            label="completeness"
                            value={!!this.state.completeness}
                            onChange={(completeness: boolean) => { this.setState({ completeness }) }}
                        />
                        <FormFieldCheckbox
                            notSolid
                            label="timeliness"
                            value={!!this.state.timeliness}
                            onChange={(timeliness: boolean) => { this.setState({ timeliness }) }}
                        />
                    </div>
                    <div className="row-2">
                        <div className="measurements">
                            <div className="form-field">
                                <label>Product types</label>
                            </div>
                            <FormFieldCheckbox
                                notSolid
                                label="All"
                                value={Object.keys(this.state.toggled_products)?.every((v) => this.state.toggled_products[v])}
                                onChange={(val: boolean) => {
                                    let { toggled_products } = this.state;
                                    for (let t in toggled_products) {
                                        toggled_products[t] = val
                                    }

                                    this.update_toggled_products(toggled_products);
                                }}
                            />
                            {
                                graphMode?.products.map((product: any, idx: number) => (
                                    <FormFieldCheckbox
                                        key={idx}
                                        notSolid
                                        label={<>
                                            {this.product_string(product)}
                                            {
                                                this.state.timeliness_data?.[idx] &&
                                                <span className="counter">{this.state.timeliness_data[idx].length}</span>
                                            }
                                        </>
                                        }
                                        value={this.state.toggled_products[idx]}
                                        onChange={(val: boolean) => {
                                            let { toggled_products } = this.state;
                                            toggled_products[idx] = val
                                            this.update_toggled_products(toggled_products);
                                        }}
                                    />
                                ))
                            }
                        </div>
                    </div>
                </div>
                <br />
                <br />

                <br />
                <br />

                {/* GRAPH */}
                <div className="title-3">Results</div>
                <Tabs
                    tabs={[
                        {
                            label: <><i className="fas fa-chart-bar" /> Graph</>,
                            content: <div className="kpi-data">
                                {
                                    this.state.refreshing ?
                                        <div className="centered">
                                            <Spinner />
                                        </div>
                                        :
                                        <>

                                            {/* ============================ 
                                            -- COMPLETENESS CHART
                                            ============================ */}
                                            {

                                                this.state.completeness_graph_data &&
                                                <div className="kpi-graph">

                                                    {
                                                        this.state.loading &&
                                                        <KPIRefreshOverlay message="Fetching data..." />
                                                    }
                                                    <TimelinessChart
                                                        // drag_mode={this.state.drag_mode}
                                                        // yFormatter={(value)=>{
                                                        //     console.log("value",)
                                                        //     return `${value}`
                                                        // }}

                                                        // dataLabelFormatter={(val, opts) => {
                                                        //     let v = this.state.completeness_graph_data?.[opts.seriesIndex];
                                                        //     return v.description.percentage ? `${v.description.percentage}` : ''
                                                        // }}
                                                        data={this.state.completeness_graph_data}
                                                        startDate={this.state.startDate}
                                                        stopDate={this.state.stopDate}
                                                        timeline_rows={this.state.timeline_rows}
                                                        data_labels={this.state.data_labels}
                                                        zoom_update={async (startDate, stopDate) => {
                                                            try {
                                                                let start = getDateTimeString(new Date(startDate), true, true);
                                                                let stop = getDateTimeString(new Date(stopDate), true, true);
                                                                await this.setState({
                                                                    startDate: start,
                                                                    stopDate: stop,
                                                                    updateStartDate: start,
                                                                    updateStopDate: stop
                                                                })
                                                                this.update_url()
                                                                this.fetch_data()
                                                            }
                                                            catch (e) {
                                                                console.error('onZoomComplete', e);
                                                            }
                                                        }}

                                                        customTooltip={(opts) => {
                                                            const data = opts.ctx.w.config.series[opts.seriesIndex].data[opts.dataPointIndex];
                                                            let { description } = data;

                                                            const start = new Date(data.y[0]);
                                                            const stop = new Date(data.y[1]);

                                                            // TITLE
                                                            let text = `<div class="chart-tt">
                                                                <div class="chart-tt-title" style="color: ${data.fillColor}">
                                                                    ${opts.ctx.w.config.series[opts.seriesIndex].name}
                                                                </div><br>`;

                                                            // DATES
                                                            text += `<div class="chart-tt-data"><label>Start:</label> ${start.toISOString()}</div>`;
                                                            text += `<div class="chart-tt-data"><label>Stop:</label> ${stop.toISOString()}</div>`;

                                                            // ADDITIONAL DATA
                                                            if (description)
                                                                text += `<div class="chart-tt-data">
                                                                    <label>Sent:</label> ${description.treated} / ${description.max} 
                                                                    - <b style="color: ${data.fillColor}">${description.percentage}</b>
                                                                </div>`;

                                                            text += `</div>`;

                                                            return text;
                                                        }}
                                                    />
                                                </div>
                                            }


                                            <FormFieldCheckbox
                                                notSolid label="Drag Mode"
                                                value={this.state.drag_mode}
                                                onChange={(drag_mode: boolean) => { this.setState({ drag_mode }) }}
                                            />

                                            {/* ============================ 
                                            -- TIMELINESS CHART
                                            ============================ */}
                                            {
                                                this.state.timeliness && this.state.timeliness_data &&
                                                <div className="kpi-graph kpi-7-graph">
                                                    {
                                                        this.state.loading &&
                                                        <KPIRefreshOverlay message="Fetching data..." />
                                                    }
                                                    <Scatter
                                                        // plugins={[ zoomPlugin  ]}
                                                        plugins={[
                                                            zoomPlugin,
                                                            // VerticalLinePlugin
                                                        ]}

                                                        options={{
                                                            responsive: true,
                                                            maintainAspectRatio: false,

                                                            scales: {
                                                                xAxes: [{
                                                                    type: 'time',
                                                                    ticks: {
                                                                        autoSkip: true,
                                                                        maxTicksLimit: 9,
                                                                        maxRotation: 0,
                                                                        minRotation: 0,
                                                                        min: moment(new Date(this.state.startDate)),
                                                                        max: moment(new Date(this.state.stopDate)),
                                                                    },
                                                                    time: {
                                                                        unit: 'hour',
                                                                        minUnit: 'second',
                                                                        displayFormats: {
                                                                            hour: 'YYYY-MM-DDTHH:mm',
                                                                            second: 'YYYY-MM-DDTHH:mm:ss'
                                                                        },
                                                                    },
                                                                }],
                                                                yAxes: [{
                                                                    ticks: {
                                                                        min: 0,
                                                                    },
                                                                    scaleLabel: {
                                                                        display: true,
                                                                        labelString: 'Distribution time (mins)',
                                                                        fontFamily: 'sans-serif',
                                                                        fontSize: '14',
                                                                        fontStyle: 'italic'
                                                                    }
                                                                }],
                                                            },
                                                            legend: {
                                                                display: true,
                                                                position: 'bottom'
                                                            },
                                                            tooltips: {
                                                                mode: 'point',
                                                                callbacks: {
                                                                    title: (tooltipItems: any, data: any) => {
                                                                        return data.datasets[tooltipItems[0].datasetIndex].data[tooltipItems[0].index].file_name;
                                                                    },
                                                                    label: (tooltipItem: any, data: any) => {
                                                                        var label = tooltipItem.value;
                                                                        return `Duration: ${this.min_to_hours(label)}`;
                                                                    },
                                                                    afterLabel: (tooltipItem: any, data: any) => {
                                                                        var xlabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].x;
                                                                        return `Upload date: ${new Date(xlabel).toISOString()}`;
                                                                    }
                                                                },
                                                            },
                                                            zoom: {
                                                                enabled: true,
                                                                onZoomComplete: async (e: any) => {
                                                                    try {
                                                                        let start = getDateTimeString(new Date(e?.chart?.scales?.['x-axis-1']?.min), true, true);
                                                                        let stop = getDateTimeString(new Date(e?.chart?.scales?.['x-axis-1']?.max), true, true);
                                                                        await this.setState({
                                                                            startDate: start,
                                                                            stopDate: stop,
                                                                            updateStartDate: start,
                                                                            updateStopDate: stop
                                                                        })
                                                                        this.update_url()
                                                                        this.fetch_data();
                                                                    }
                                                                    catch (e) { }
                                                                },
                                                                drag: this.state.drag_mode,
                                                                wheel: !this.state.drag_mode,
                                                                mode: 'x',
                                                            },
                                                            animation: {
                                                                duration: 0
                                                            }
                                                        }}

                                                        data={{
                                                            labels: toggled_product_names,
                                                            datasets: [
                                                                // PRODUCTS
                                                                ...toggled_products.map((p: any) => {
                                                                    let idx = this.get_product_index(p);
                                                                    return {
                                                                        label: this.product_string(p),
                                                                        borderColor: COLORS[idx],
                                                                        // 4b is around 40% opacity
                                                                        backgroundColor: COLORS[idx] + '4b',
                                                                        data: this.state.timeliness_data[idx]?.map((p: any) => {
                                                                            return {
                                                                                y: p.duration,
                                                                                x: date_timezone_compensated(p.upload_date),
                                                                                name: p.file_name
                                                                            }
                                                                        })
                                                                    }
                                                                })
                                                            ]
                                                        }}
                                                    />
                                                </div>
                                            }
                                        </>
                                }

                            </div>
                        },
                        {
                            label: <><i className="fas fa-th-list" /> Data</>,
                            content:
                                <Tabs
                                    tabs={[
                                        {
                                            label: <><i className="fas fa-link" /> Completeness</>,
                                            content: <div className="kpi-data">
                                                {

                                                    this.state.refreshing ?
                                                        <div className="centered">
                                                            <Spinner />
                                                        </div>
                                                        :
                                                        <>
                                                            {/* ============================ 
                                                        -- COMPLETENESS DATA
                                                        ============================ */}
                                                            {
                                                                this.state.completeness && this.state.timeliness_data &&
                                                                toggled_products.map((p: any) => {
                                                                    let idx = this.get_product_index(p)
                                                                    return (
                                                                        <KPITable
                                                                            key={idx}
                                                                            title={`Completeness ${this.product_string(p)}`}
                                                                            counter={this.state.timeliness_data[idx]?.length}
                                                                        >
                                                                            {
                                                                                this.state.loading &&
                                                                                <KPIRefreshOverlay message="Fetching data..." />
                                                                            }
                                                                            <table className="table-kpi">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>File Name</th>
                                                                                        <th style={{ width: 120 }}>Sent</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {
                                                                                        this.state.timeliness_data[idx]?.map((d: any, key: number) => (
                                                                                            <tr key={key}>
                                                                                                <td>{d.file_name}</td>
                                                                                                <td
                                                                                                    width={150}
                                                                                                    style={{ textAlign: 'center' }}
                                                                                                >
                                                                                                    {(!!d.upload_date).toString()}
                                                                                                </td>
                                                                                            </tr>
                                                                                        ))
                                                                                    }
                                                                                </tbody>
                                                                            </table>
                                                                        </KPITable>
                                                                    )
                                                                })
                                                            }
                                                        </>
                                                }
                                            </div>
                                        },
                                        {
                                            label: <><i className="fas fa-calendar-alt" /> Timeliness</>,
                                            content: <div className="kpi-data">
                                                {
                                                    this.state.refreshing ?
                                                        <div className="centered">
                                                            <Spinner />
                                                        </div>
                                                        :
                                                        <>
                                                            {/* ============================ 
                                                        -- TIMELINESS DATA 
                                                        ============================ */}
                                                            {
                                                                this.state.timeliness && this.state.timeliness_data &&
                                                                toggled_products.map((p: any) => {
                                                                    let idx = this.get_product_index(p)
                                                                    return (
                                                                        <KPITable
                                                                            title={`Timeliness ${this.product_string(p)}`}
                                                                            counter={this.state.timeliness_data[idx]?.length}
                                                                        >
                                                                            {
                                                                                this.state.loading &&
                                                                                <KPIRefreshOverlay message="Fetching data..." />
                                                                            }
                                                                            <table className="table-kpi">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>File Name</th>
                                                                                        <th>Session stop time</th>
                                                                                        <th>Upload date</th>
                                                                                        <th>Difference</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {
                                                                                        this.state.timeliness_data[idx]?.map((p: any, key: number) => (
                                                                                            <tr key={key}>
                                                                                                <td>{p.file_name}</td>
                                                                                                <td>{p.downlink_session.stop_date_time}</td>
                                                                                                <td>{p.upload_date}</td>
                                                                                                <td>{this.min_to_hours(p.duration) || '-'}</td>
                                                                                            </tr>
                                                                                        ))
                                                                                    }
                                                                                </tbody>
                                                                            </table>
                                                                        </KPITable>
                                                                    )
                                                                })
                                                            }
                                                        </>
                                                }
                                            </div>
                                        }
                                    ]}
                                />

                        }
                    ]}
                />

                <br />
                <br />
                {/* DOWNLOAD */}
                <div className="title-3">Export</div>
                <p>Export Data used to compute the KPI</p>

                <FormFieldCheckbox
                    notSolid label="JSON Format"
                    value={!!this.state.json_format}
                    onChange={(json_format: boolean) => { this.setState({ json_format }) }}
                />
                <a
                    className={classNames({
                        "custom-button medium inline": true,
                        "disabled": !this.type_selected()
                    })}
                    href={this.download_url()} download
                >
                    <i className="fas fa-cloud-download-alt" /> Export
                </a>
            </KPIs>
        );
    }

    type_selected = () => {
        return (this.state.completeness || this.state.timeliness)
    }

    download_url = () => {
        let indexes = this.get_toggled_products()?.map((p: any) => {
            return this.get_product_index(p);
        });
        let params = [
            'export=true',
            `graph_mode=${this.state.graphMode}`,
            `exports=${indexes?.join(',')}`,
            `start_date=${this.state.startDate}Z`,
            `stop_date=${this.state.stopDate}Z`
        ];

        let export_types = [];
        if (this.state.completeness) export_types.push('completeness');
        if (this.state.timeliness) export_types.push('timeliness');
        if (export_types.length > 0) params.push(`export_types=${export_types.join(',')}`);

        if (this.state.json_format) params.push('format=json');

        return `${API_URL}/api/v1/eumetsat?${params.join('&')}`
    }

    date_day_diff = (start: string, stop: string) => {
        let hours = Math.round(
            (new Date(stop).getTime() - new Date(start).getTime())
            / (1000 * 3600)
        )
        if (hours >= 24) {
            let days = (hours / 24);
            return `${days.toFixed(0)} Day${days >= 2 ? 's' : ''}`
        }
        return `${hours} Hour${hours >= 2 ? 's' : ''}`
    }
    min_to_hours = (mins: number) => {
        let hours = Math.floor(mins / 60);
        let _min = mins - (hours * 60);
        let min = Math.floor(_min)
        let s = Math.floor((_min - min) * 60);

        return `${hours ? `${hours}h` : ''}${min ? `${min}m` : ''}${s ? `${s}s` : ''}`
    }


};


export default connect((state: any) => {
    return {
        kpi: state.kpi,
        product_types: state.product_types
    }
})(KPI7)